<template>
  <div class="ar d-flex">
    <div class="ar-center">
      <div class="ar-duration text-center">{{recordedTime}}</div>
      <div class="ar-recorder text-center">
        <v-btn icon @click.native="toggleRecorder" large>
          <v-icon large>
            {{iconButtonType}}
          </v-icon>
        </v-btn>
      </div>
      <div class="text-center">
        <v-btn @click="choiceFile" :loading="fileUpload.detacting">
          {{$t('Form.choiceFile')}}
        </v-btn>
        <v-btn @click="submitFile()" style="padding-left:1rem;" v-if="fileUpload.file && fileUpload.validated">
          上傳: {{fileUpload.file.name}} / 長度: {{fileUpload.duration.toFixed(2)}}秒
        </v-btn>
      </div>
      <input
        type="file"
        style="display:none;"
        ref="file-input"
        @change="onFileChange"
      />
      <audio
        v-if="fileUpload.file"
        ref="audioElement"
        src=""
      />
    </div>
  </div>
</template>

<script>
import Recorder from './lib/recorderV2'
import { convertTimeMMSS, fileToDataURL } from './lib/utils'

export default {
  props: {
    time: { type: Number },

    bitRate: { type: Number, default: 128 },
    sampleRate: { type: Number, default: 44100 },

    showDownloadButton: { type: Boolean, default: true },
    showUploadButton: { type: Boolean, default: true },

    micFailed: { type: Function }
  },
  computed: {
    iconButtonType() {
      return this.isRecording && this.isPause ? 'mdi-microphone' : this.isRecording ? 'mdi-stop' : 'mdi-microphone'
    },
    isPause() {
      return this.recorder.isPause
    },
    isRecording() {
      return this.recorder && this.recorder.isRecording
    },
    recordedTime() {
      // 錄音上限 60 秒
      if(this.recorder){
        if(this.time && this.recorder.duration >= this.time * 60) {
          this.stopRecorder()
        }
        return convertTimeMMSS(this.recorder.duration)
      }
      return convertTimeMMSS(0)
    },
    volume() {
      return parseFloat(this.recorder.volume)
    }
  },
  data() {
    return {
      showRecorder: true,
      recorder: null,
      record: [],
      uploadStatus: null,
      fileUpload: {
        file: null,
        dataURL: null,
        duration: 0,
        detacting: false, // 檢測中
        validated: false, // 檢測成功 (是音訊 + 可以播放)
        error: false
      }
    }
  },
  created(){
    this.recorder = this._initRecorder()
  },
  mounted() {
  },
  beforeDestroy() {
    this.stopRecorder()
  },
  methods: {
    choiceFile() {
      this.$refs['file-input'].click()
    },
    onFileChange(e){
      if(e.target.files.length > 0){
        this.fileUpload.file = e.target.files[0]
        if(this.$runner && this.$runner.cancel){
          this.$runner.cancel()
          if(this.$durationDetector){
            clearInterval(this.$durationDetector)
            this.$durationDetector = null
          }
        }
        this.fileUpload.validated = false
        this.fileUpload.duration = 0
        this.fileUpload.error = false
        this.fileUpload.detacting = true
        this.$runner = fileToDataURL(this.fileUpload.file)
          .then((dataURL)=>{
            if(dataURL){
              this.fileUpload.dataURL = dataURL
              this.$refs.audioElement.src = dataURL
              // 嘗試次數
              let times = 0
              if(this.$durationDetector){
                clearInterval(this.$durationDetector)
                this.$durationDetector = null
              }
              this.$durationDetector = setInterval(()=>{
                console.log(this.$refs.audioElement.duration)
                if(this.$refs.audioElement.src){
                  // 嘗試取得 duration
                  if(!Number.isNaN(this.$refs.audioElement.duration)){
                    this.fileUpload.detacting = false
                    this.fileUpload.validated = true
                    this.fileUpload.duration = this.$refs.audioElement.duration
                    clearInterval(this.$durationDetector)
                    this.$durationDetector = null
                  }
                }
                times += 1
                // 限制嘗試次數
                if(times > 15){
                  if(this.$durationDetector){
                    this.fileUpload.detacting = false
                    this.fileUpload.validated = false
                    this.fileUpload.error = '不支援的檔案類型'
                    this.$toast.error('不支援的檔案類型')
                    this.clearFile()
                    clearInterval(this.$durationDetector)
                    this.$durationDetector = null
                  }
                }
              }, 300)
            }
          })
          .catch((e)=>{
            this.fileUpload.error = e.message
            // this.$toast.error('可能不支援該檔案')
            console.error(e)
          })
      }else{
        this.clearFile()
      }
    },
    submitFile() {
      let payload = {
        clearSelectedFile: ()=>{
          this.clearFile()
        },
        file: this.fileUpload.file,
        url: this.fileUpload.dataURL,
        duration: this.fileUpload.duration
      }
      this.$emit('submit-file', payload)
    },
    clearFile() {
      this.$refs['file-input'].value = []
      this.fileUpload.file = null
      this.fileUpload.dataURL = null
      this.fileUpload.validated = false
    },
    toggleRecorder() {
      if(!this.isRecording || (this.isRecording && this.isPause)) {
        this.recorder.start()
      } else {
        this.recorder.stop()
      }
    },
    stopRecorder() {
      if(!this.isRecording) {
        return
      }
      this.recorder.stop({ cancel: true })
    },
    onRecorderEvent(e){
      this.$emit('recorder-event', e)
      switch(e.type){
        case 'after-recording':
          let record = e.record
          fileToDataURL(record.blob)
            .then((url)=>{
              record.url = url
              this.$emit('submit-record', record)
            })
          break
      }
    },
    _initRecorder() {
      return new Recorder({
        beforeRecording: this.onRecorderEvent,
        afterRecording: this.onRecorderEvent,
        pauseRecording: this.onRecorderEvent,
        micFailed: this.micFailed,
        bitRate: this.bitRate,
        sampleRate: this.sampleRate,
        format: this.format
      })
    },
    convertTimeMMSS(time){
      return convertTimeMMSS(time)
    }
  }
}
</script>
<style scoped>
  .ar{
    min-height: 120px;
  }
</style>
